import LogRocket from 'logrocket';

LogRocket.init('1z4c2a/aura-frames', { rootHostname: 'auraframes.com' });
